import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import {
    GeneralUserTypeChoice,
    UserAuthorityChoice,
    getGeneralUserTypeName,
    getUserAuthorityName,
} from "../utils/common";
import { apiWrapper } from "../apis/CommonApi";
import * as accountApi from "../apis/AccountApi";
import { useAppContext } from "../utils/store";
import { API_HOST } from "Constants";

export default function UserAccountPage() {
    const navigate = useNavigate();
    const {
        store: { id, userId, userName, userAuthority },
    } = useAppContext();
    const [isPasswordMatch, setPasswordMatch] = useState(false); // 비밀번호 일치 여부
    const [isCompletedPassword, setCompletedPassword] = useState(false); // 비밀번호 입력 완료 여부
    const [isCompletedPasswordConfirm, setCompletedPasswordConfirm] =
        useState(false); // 비밀번호 확인 입력 완료 여부
    const [formData, setFormData] = useState(null);

    useEffect(() => {
        setFormDataProperty("password", "");
        setFormDataProperty("passwordConfirm", "");
        setFormDataProperty("title", "");
        setFormDataProperty("phoneNumber", "");
        setFormDataProperty("email", "");
        setFormDataProperty("businessNumber", "");
        setFormDataProperty("userType", GeneralUserTypeChoice.FIRE_SAFETY_ADMIN);
        setFormDataProperty("profileImageSrc", "");
        setFormDataProperty("profileImageFile", null);

        apiWrapper(async () => {
            const { status, data } = await accountApi.getUser(id);
            if (status === true) {
                setFormDataProperty("phoneNumber", data.phoneNumber);
                setFormDataProperty("email", data.email);
                setFormDataProperty("profileImageSrc", API_HOST + data.profileImage);
                //이미지 URL -> Blob 변환
                try {
                    const response = await fetch(API_HOST + data.profileImage);
                    if (!response.ok) {
                        throw new Error(`${response.status}`);
                    }

                    const blob = await response.blob();
                    const file = new File([blob], "", { type: blob.type });
                    setFormDataProperty("profileImageFile", file);
                } catch (error) {
                    console.error("이미지 URL을 Blob 객체로 변환 실패 : ", error)
                }

                if (data.userAuthority === UserAuthorityChoice.BUSINESS) {
                    setFormDataProperty(
                        "businessNumber",
                        data.businessData.businessNumber
                    );
                } else if (data.userAuthority === UserAuthorityChoice.GENERAL) {
                    setFormDataProperty("title", data.generalData.title);
                    setFormDataProperty("userType", data.generalData.userType);
                }
            }
        });
    }, []);

    const setFormDataProperty = (name, value) => {
        setFormData((currentFormData) => {
            const nextFormData = {
                ...currentFormData,
                [name]: value,
            };
            //console.log(nextFormData);
            return nextFormData;
        });
    };

    const onChange = (e) => {
        if (e.target.type === 'file') {
            const files = e.target.files;
            if (files.length > 0) {
                const reader = new FileReader();
                reader.onload = (e) => {
                    const image = e.target.result;
                    setFormDataProperty("profileImageSrc", image);
                    setFormDataProperty("profileImageFile", files[0]);
                };
                reader.readAsDataURL(files[0]);
            }
        } else {
            let name = e.target.name;
            let value = e.target.value;
            setFormDataProperty(name, value);
        }
    };

    const handleSubmit = (e) => {
        e.preventDefault();

        const form = e.currentTarget;
        if (form.checkValidity() === false) {
            e.stopPropagation();
        } else if (checkValid() === false) {
            e.stopPropagation();
        } else {
            apiWrapper(async () => {
                const requestBody = new FormData();
                let payload = {
                    password: formData.password,
                    phoneNumber: formData.phoneNumber.trim().replace(/-/g, ""),
                    email: formData.email,
                };

                if (userAuthority === UserAuthorityChoice.BUSINESS) {
                    //사업자
                    payload = {
                        ...payload,
                        businessData: {
                            businessNumber: formData.businessNumber,
                        },
                    };
                } else if (userAuthority === UserAuthorityChoice.GENERAL) {
                    //사용자
                    payload = {
                        ...payload,
                        generalData: {
                            userType: formData.userType,
                            title: formData.title,
                        },
                    };
                }

                requestBody.append("profileImage", formData.profileImageFile);
                requestBody.append("data", JSON.stringify(payload));

                const { status, data } = await accountApi.updateUser(id, requestBody);
                alert(`${data}`);

                if (status === true) {
                    navigate("/");
                }
            });
        }
    };

    const checkValid = () => {
        if (isPasswordMatch === false) {
            alert("비밀번호를 확인해주세요.");
            return false;
        } else if (formData.profileImageFile === null) {
            alert(`프로필 이미지를 선택해주세요.`);
            return false;
        }

        return true;
    };

    const handleCheckPasswordMatch = () => {
        if (formData.password === formData.passwordConfirm) {
            setPasswordMatch(true);
        } else {
            setPasswordMatch(false);
        }
    };

    return (
        <section className="joinSection">
            <div className="container cont-960">
                <form onSubmit={handleSubmit}>
                    <div className="whiteBoard wrap_join">
                        <button type="button" className="btn_prev" onClick={() => navigate(-1)}>
                            <i className="x-icon icon_prev"></i>
                        </button>
                        <p className="title_whiteBoard">회원정보</p>
                        {formData && (
                            <div className="wrap_input">
                                <div className="item_input">
                                    <p className="title_item">구분</p>
                                    <div className="wrap_inner wrap_radio_inner">
                                        {/* "전체" 상태는 제외하고 전시 */}
                                        {Object.values(UserAuthorityChoice).map((item, index) =>
                                            index === 0 ? null : (
                                                <label
                                                    className={`radio-item ${userAuthority === item ? "active" : ""
                                                        }`}
                                                >
                                                    <input
                                                        type="radio"
                                                        class="form-radio"
                                                        name="userAuthority"
                                                        value={item}
                                                        checked={userAuthority === item}
                                                    />
                                                    <span className="radio-icon">
                                                        <i className="xi-check"></i>
                                                    </span>
                                                    <p className="radio-title">
                                                        {getUserAuthorityName(item)}
                                                    </p>
                                                </label>
                                            )
                                        )}
                                    </div>
                                </div>

                                <div className="item_input">
                                    <p className="title_item">아이디</p>
                                    <div className="wrap_inner type2">
                                        <div className="wrap_enter">
                                            <input
                                                type="text"
                                                className="defaultInput"
                                                name="userId"
                                                value={userId}
                                                readOnly
                                            />
                                        </div>
                                    </div>
                                </div>

                                <div className="item_input">
                                    <p className="title_item">패스워드</p>
                                    <input
                                        type="password"
                                        className="defaultInput"
                                        name="password"
                                        value={formData.password}
                                        onChange={onChange}
                                        onBlur={() => {
                                            formData.password
                                                ? setCompletedPassword(true)
                                                : setCompletedPassword(false);
                                            handleCheckPasswordMatch();
                                        }}
                                        required="required"
                                    />
                                </div>

                                <div className="item_input">
                                    <p className="title_item">패스워드 확인</p>
                                    <div className="wrap_inner type2">
                                        <div className="wrap_enter">
                                            <input
                                                type="password"
                                                className="defaultInput"
                                                name="passwordConfirm"
                                                value={formData.passwordConfirm}
                                                onChange={onChange}
                                                onBlur={() => {
                                                    formData.passwordConfirm
                                                        ? setCompletedPasswordConfirm(true)
                                                        : setCompletedPasswordConfirm(false);
                                                    handleCheckPasswordMatch();
                                                }}
                                                required="required"
                                            />
                                        </div>
                                        {isCompletedPassword &&
                                            isCompletedPasswordConfirm &&
                                            isPasswordMatch === false && (
                                                <div className="wrap_guide red">
                                                    <i className="x-icon txt_guide"></i>
                                                    <p className="txt_guide">
                                                        패스워드가 동일하지 않습니다.
                                                    </p>
                                                </div>
                                            )}
                                    </div>
                                </div>

                                <div className="item_input">
                                    <p className="title_item">사용자 명</p>
                                    <input
                                        type="text"
                                        className="defaultInput"
                                        name="userName"
                                        value={userName}
                                        readOnly
                                    />
                                </div>

                                {userAuthority === UserAuthorityChoice.GENERAL && (
                                    <div className="item_input">
                                        <p className="title_item">직함/직책</p>
                                        <input
                                            type="text"
                                            className="defaultInput"
                                            name="title"
                                            value={formData.title}
                                            onChange={onChange}
                                            required="required"
                                        />
                                    </div>
                                )}

                                <div className="item_input">
                                    <p className="title_item">연락처</p>
                                    <input
                                        type="text"
                                        className="defaultInput"
                                        name="phoneNumber"
                                        value={formData.phoneNumber}
                                        onChange={onChange}
                                        required="required"
                                    />
                                </div>

                                <div className="item_input">
                                    <p className="title_item">이메일</p>
                                    <div className="wrap_inner type2">
                                        <div className="wrap_enter">
                                            <input
                                                type="text"
                                                className="defaultInput"
                                                name="email"
                                                value={formData.email}
                                                readOnly
                                            />
                                        </div>
                                    </div>
                                </div>

                                {formData.userAuthority === UserAuthorityChoice.BUSINESS && (
                                    <>
                                        <div className="item_input">
                                            <p className="title_item">사업자 번호</p>
                                            <input
                                                type="number"
                                                className="defaultInput"
                                                name="businessNumber"
                                                value={formData.businessNumber}
                                                onChange={onChange}
                                                required="required"
                                            />
                                        </div>
                                    </>
                                )}

                                {formData.userAuthority === UserAuthorityChoice.GENERAL && (
                                    <>
                                        <div className="item_input">
                                            <p className="title_item">사용자 구분</p>
                                            <div className="wrap_inner type2">
                                                <div className="wrap_radio">
                                                    {Object.values(GeneralUserTypeChoice).map(
                                                        (item, index) => (
                                                            <label className="radio-item">
                                                                <input
                                                                    type="radio"
                                                                    class="form-radio"
                                                                    name="userType"
                                                                    key={index}
                                                                    value={item}
                                                                    checked={formData.userType === item}
                                                                    onChange={onChange}
                                                                />
                                                                <span className="radio-icon">
                                                                    <i className="xi-check"></i>
                                                                </span>
                                                                <p className="radio-title">
                                                                    {getGeneralUserTypeName(item)}
                                                                </p>
                                                            </label>
                                                        )
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                    </>
                                )}

                                <div className="item_input">
                                    <p className="title_item">프로필 이미지</p>
                                    <div class="file-input">
                                        <label for="file-upload" class="file-upload-btn">+</label>
                                        <input type="file" accept=".png, .jpg, .jpeg" id="file-upload" class="file-upload-input" name="profileImage" onChange={onChange} />
                                        {formData.profileImageFile && (
                                            <div class="wrap_profile">
                                                <div class="icon-item">
                                                    <img src={formData.profileImageSrc} alt="" />
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>
                        )}
                        <button type="submit" className="btn_orange btn_signup">
                            저장
                        </button>
                    </div>
                </form>
            </div>
        </section>
    );
}
